import { useState } from 'react';

/**
 * FadeImage - An image component that fades in smoothly when loaded
 * Prevents the "flash" effect when switching pages
 */
export default function FadeImage({ src, alt, className, style, ...props }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  // Show skeleton while loading or on error
  const showSkeleton = !loaded || error || !src;

  return (
    <div className={`relative ${className || ''}`} style={style} {...props}>
      {/* Skeleton loader - always present, hidden when image loads */}
      <div 
        className={`absolute inset-0 bg-gradient-to-br from-[#1a1a1a] via-[#252525] to-[#1a1a1a] ${showSkeleton ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
        style={{
          backgroundSize: '200% 200%',
          animation: showSkeleton ? 'skeleton-pulse 1.5s ease-in-out infinite' : 'none'
        }}
      />
      
      {/* Actual image */}
      {src && !error && (
        <img
          src={src}
          alt={alt || ''}
          className={`w-full h-full object-cover transition-opacity duration-500 ${loaded ? 'opacity-100' : 'opacity-0'}`}
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
        />
      )}
    </div>
  );
}
